"use client";

import * as React from "react";
import { cn } from "@/lib/utils";
import * as SelectPrimitive from "@radix-ui/react-select";

function Select({
  ...props
}: React.ComponentProps<typeof SelectPrimitive.Root>) {
  return <SelectPrimitive.Root data-slot="select" {...props} />;
}

function SelectValue({
  ...props
}: React.ComponentProps<typeof SelectPrimitive.Value>) {
  return <SelectPrimitive.Value data-slot="select-value" {...props} />;
}

function SelectTrigger({
  className,
  ...props
}: React.ComponentProps<typeof SelectPrimitive.Trigger>) {
  return (
    <SelectPrimitive.Trigger
      data-slot="select-trigger"
      className={cn(
        "flex justify-between items-center bg-white disabled:opacity-50 px-3 py-2 border border-input rounded-md outline-hidden focus:ring-2 focus:ring-ring w-full h-10 text-sm disabled:cursor-not-allowed",
        "data-placeholder:text-muted-foreground",
        className,
      )}
      {...props}
    />
  );
}

function SelectContent({
  className,
  children,
  position = "popper",
  portalled = true,
  ...props
}: React.ComponentProps<typeof SelectPrimitive.Content> & {
  portalled?: boolean;
}) {
  const content = (
    <SelectPrimitive.Content
      data-slot="select-content"
      className={cn(
        "z-[100] relative bg-white shadow-md border rounded-md min-w-32 max-h-96 overflow-hidden text-black",
        className,
      )}
      position={position}
      {...props}
    >
      <SelectPrimitive.Viewport className="p-1">{children}</SelectPrimitive.Viewport>
    </SelectPrimitive.Content>
  );

  if (!portalled) {
    return content;
  }

  return <SelectPrimitive.Portal>{content}</SelectPrimitive.Portal>;
}

function SelectItem({
  className,
  children,
  ...props
}: React.ComponentProps<typeof SelectPrimitive.Item>) {
  return (
    <SelectPrimitive.Item
      data-slot="select-item"
      className={cn(
        "relative flex items-center focus:bg-accent py-1.5 pr-8 pl-2 rounded-sm outline-hidden w-full text-sm focus:text-accent-foreground cursor-default select-none",
        className,
      )}
      {...props}
    >
      <SelectPrimitive.ItemText>{children}</SelectPrimitive.ItemText>
    </SelectPrimitive.Item>
  );
}

export { Select, SelectContent, SelectItem, SelectTrigger, SelectValue };
